<template>
    <div class="css-1n7k36">
        <div class="MuiBox-root css-rslmm8">
            <div class="MuiGrid-root MuiGrid-container css-17x1xqc">
                <div class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-1 css-1kptzrq">
                    <div class="MuiGrid-root MuiGrid-container MuiGrid-item css-19bqh9k">
                        <div></div>
                        <div
                            class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-auto css-1e79m6y">
                            <button @click="toHome"
                                class="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-nsievr"
                                tabindex="0" type="button" data-testid="backButton">
                                <div
                                    class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-true css-c98b2r">
                                    <svg class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-o261au"
                                         focusable="false" aria-hidden="true" viewBox="0 0 24 24"
                                         data-testid="ChevronLeftIcon">
                                        <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                                    </svg>
                                    <p class="MuiBox-root MuiBox-root__p css-1ldmngi"><b>COHN</b></p>
                                </div>
                                <span class="MuiTouchRipple-root css-w0pj6f"></span>
                            </button>
                        </div>
                    </div>
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-auto css-efew0w" section="1">
                        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true css-1301l50"><p
                            class="MuiTypography-root MuiTypography-body2 css-1gl7kvp">Section {{ current }} of {{ elements }}</p></div>
                        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-auto css-z5nz7c">
                            <p class="MuiTypography-root MuiTypography-body2 css-174j1p8">
                                Share info about your trademark
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-wrap-xs-nowrap MuiGrid-grid-xs-auto css-6lqwdg"
                    data-testid="header-title">
                    <div class="MuiGrid-root MuiGrid-item MuiGrid-zeroMinWidth MuiGrid-grid-xs-true css-c6pfyv">
                        <h5 class="MuiTypography-root MuiTypography-h5 css-g73sdp"></h5>

                    </div>
                </div>
                <div class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-auto css-1e79m6y">
                    <div class="MuiGrid-root MuiGrid-container MuiGrid-item css-yxncuq">
                        <div class="MuiGrid-root MuiGrid-item css-1wxaqej" data-testid="header-contact-us">
                            <div></div>
                            <div class="MuiGrid-root MuiGrid-container MuiGrid-item css-gi3w5v">
                                <button
                                    @click="openPopup"
                                    class="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeMedium MuiButton-textSizeMedium css-ls67vh"
                                    tabindex="0" type="button" data-testid="contactUsButton">
                                    <div
                                        class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-true css-13wt736">
                                        <div
                                            class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-true css-riqv0d">
                                            <img class="MuiBox-root css-1qjrdjk"
                                                 src="/images/icons8-chat-64.png"
                                                 alt="none"></div>
                                    </div>
                                    <span class="MuiTouchRipple-root css-w0pj6f"></span></button>
                            </div>
                            <div
                                class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-grid-xs-true css-8r25k5">
                                <div class="MuiGrid-root MuiGrid-container css-ue5ebe">
                                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true css-1kqxtm6"
                                         data-testid="header-total-due-today"><p
                                        class="MuiTypography-root MuiTypography-body2 css-1gl7kvp">Amount due:</p></div>
                                    <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true css-1kqxtm6"
                                         data-testid="header-total-due-today">
                                        <p style="font-size: 18px;" class="MuiTypography-root MuiTypography-body2 css-1gr8x4t">${{ total }}</p></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="MuiGrid-root MuiGrid-container MuiGrid-item css-1ul47bz">
                <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true css-31khnh">
                    <div class="MuiGrid-root MuiGrid-container MuiGrid-item css-1jc9fpl">
                        <div v-for="element in elementsArr" class="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-true css-1ubyu7x"></div>
                    </div>
                    <span
                        class="MuiLinearProgress-root MuiLinearProgress-colorPrimary MuiLinearProgress-buffer css-1vm1q2p"
                        role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
                        data-testid="flow-progress"><span
                        class="MuiLinearProgress-dashed MuiLinearProgress-dashedColorPrimary css-1j4zh7k"></span><span
                        class="MuiLinearProgress-bar MuiLinearProgress-barColorPrimary MuiLinearProgress-bar1Buffer css-18t10rf"
                        style="transform: translateX(-100%);"></span><span
                        class="MuiLinearProgress-bar MuiLinearProgress-colorPrimary MuiLinearProgress-bar2Buffer css-vq5x7l"
                        :style="'transform: translateX(-' + transform + '%);'"></span></span></div>
            </div>
        </div>
    </div>
    <InfoPopup></InfoPopup>
</template>

<script>
import InfoPopup from '@/components/InfoPopup.vue'
import {mapGetters} from "vuex";

export default {
    components: {
        InfoPopup
    },
    props: ['elements', 'current'],
    methods: {
        openPopup() {
            this.$store.commit('header/setPopupTitle', 'How can we help?');
            this.$store.commit('header/setPopupStatus', true);
        },
        toHome() {
            if (
                this.$route.path.indexOf('trademark-office-action') > -1 ||
                this.$route.path.indexOf('statement-of-use') > -1 ||
                this.$route.path.indexOf('statement-of-use-extension') > -1 ||
                this.$route.path.indexOf('trademark-renewal') > -1 ||
                this.$route.path.indexOf('trademark-revival') > -1
            ) {
                this.$store.commit('back/setUrl', '/');
                this.$store.commit('back/setStatus', true);
            } else {
                this.$router.push('/')
            }
        }
    },
    computed: {
        elementsArr() {
            let arr = []
            for (let i = 0; i < this.elements; i++) {
                arr.push(1)
            }

            return arr
        },
        transform() {
            return 100 - (this.current / this.elements * 100)
        },
        ...mapGetters('header', {
            total: 'getTotal',
            popup_status: 'getPopupStatus',
            popup_title: 'getPopupTitle',
        })
    },
}
</script>
